import { render, staticRenderFns } from "./SaveCloseButton.vue?vue&type=template&id=7234f585&"
import script from "./SaveCloseButton.vue?vue&type=script&lang=js&"
export * from "./SaveCloseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports